import { CONTENT as previewCs } from '@flowup/content/generated/preview/cs/content';
import { CONTENT as previewEn } from '@flowup/content/generated/preview/en/content';
import { EnvironmentModel } from '../app/common/models';

export const environment: EnvironmentModel = {
  appEnv: 'staging',
  sentry: {
    dsn: 'https://6cdc6102b8cd49aca4da3183943ad0ba@o401493.ingest.sentry.io/5261167',
    environment: 'staging',
    tracesSampleRate: 1,
  },
  content: { en: previewEn, cs: previewCs },
  robots: 'noindex',
};
